var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQqIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_5401",
    "data-name": "Group 5401",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48,
    height: 32,
    viewBox: "0 0 48 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1726",
    "data-name": "Rectangle 1726",
    width: 48,
    height: 32,
    fill: "#f38530"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_5",
    "data-name": "Mask Group 5",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "QQ",
    transform: "translate(0.552)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5406",
    "data-name": "Group 5406"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_5",
    d: "M16,4.013a11.987,11.987,0,0,0,0,23.975H29.743a11.987,11.987,0,0,0,0-23.975H16M16,0H29.743a16,16,0,0,1,0,32H16A16,16,0,0,1,16,0Z",
    fill: "#14464f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6",
    width: 24.075,
    height: 4.013,
    transform: "translate(22.821 27.987)",
    fill: "#14464f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5408",
    "data-name": "Group 5408"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M16,4.013H29.743a11.987,11.987,0,0,1,0,23.975H16A11.987,11.987,0,0,1,16,4.013Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5407",
    "data-name": "Group 5407"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_9",
    cx: 2.809,
    cy: 2.809,
    r: 2.809,
    transform: "translate(28.74 7.223)",
    fill: "#f38530"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M40.12,16.236A10.392,10.392,0,0,1,29.738,26.382H15.995a10.346,10.346,0,0,1-4.665-1.108q.105-.173.226-.346l.06-.09c.01-.01.015-.025.025-.035.02-.025.035-.05.055-.075.06-.085.12-.166.186-.251.02-.025.04-.055.06-.08l.045-.06c.055-.065.105-.135.161-.2.025-.025.045-.055.07-.08l.075-.09c.06-.07.125-.14.186-.211.035-.035.065-.07.1-.11.005,0,.01-.01.015-.015.035-.035.065-.07.1-.105s.085-.085.125-.13l.1-.1.226-.211a.016.016,0,0,0,.01-.005c.04-.035.08-.07.115-.105l.1-.085c.13-.11.261-.216.391-.321l.12-.09c.171-.125.346-.251.522-.366.045-.03.09-.06.135-.085s.09-.055.135-.085l.12-.075.03-.02c.04-.025.08-.045.12-.07s.09-.05.14-.075l.14-.075a1.6,1.6,0,0,1,.161-.08l.125-.06.145-.07c.05-.025.1-.045.145-.065s.1-.045.15-.065a1.073,1.073,0,0,0,.11-.05c.02-.01.04-.015.06-.025h0c.085-.035.171-.07.261-.1.035-.01.065-.025.1-.035l.09-.03c.1-.035.2-.07.3-.1a1.383,1.383,0,0,1,.135-.04c.1-.03.2-.06.3-.085a.525.525,0,0,1,.085-.02c.03-.01.06-.015.1-.025.05-.015.105-.025.155-.04s.1-.025.15-.035h.01c.055-.01.105-.025.161-.035.04-.01.085-.015.13-.025a.4.4,0,0,0,.075-.015c.085-.015.166-.03.251-.04l.09-.015.12-.015a.761.761,0,0,0,.105-.015.5.5,0,0,0,.08-.01l.13-.015c.045,0,.085-.01.13-.01a.685.685,0,0,0,.1-.01h.025a.82.82,0,0,0,.11-.01l.271-.015h.381a10.133,10.133,0,0,1,5.7,1.755c.06-.191.125-.381.191-.567.025-.06.045-.125.07-.186.015-.035.03-.075.045-.11l.045-.105v-.005c.025-.055.05-.115.075-.171.01-.02.015-.035.025-.055.02-.045.04-.1.065-.14.005-.01.01-.025.015-.035.02-.045.04-.085.06-.13a.935.935,0,0,1,.05-.1c.01-.025.025-.05.035-.07a1.062,1.062,0,0,1,.055-.105c.015-.025.025-.05.04-.08s.03-.05.045-.08.04-.07.06-.11c.01-.02.025-.04.035-.06l.06-.105a.7.7,0,0,1,.05-.08c.015-.03.035-.055.05-.08a.817.817,0,0,1,.055-.085c.02-.03.04-.065.06-.1a.3.3,0,0,1,.035-.05c.035-.05.065-.1.1-.145s.065-.1.1-.14l.03-.045c.03-.04.055-.08.085-.115.01-.015.02-.025.03-.04l.08-.11.045-.06c.03-.035.055-.07.085-.11.01-.01.02-.025.03-.035.03-.035.06-.075.09-.11.015-.015.025-.035.04-.05a.872.872,0,0,1,.065-.075l.075-.09.03-.03c.03-.035.065-.075.1-.11s.08-.085.12-.125.09-.1.14-.145l.06-.06c.075-.075.15-.145.226-.221.186-.176.381-.346.582-.507l.145-.115h0c.055-.04.11-.085.166-.125s.1-.075.15-.11a.212.212,0,0,1,.035-.025c.105-.075.216-.15.326-.221h0c.11-.07.226-.14.336-.211a.016.016,0,0,0,.01-.005c.055-.03.105-.06.161-.1a.038.038,0,0,0,.02-.01c.05-.03.1-.055.155-.085l.035-.02c.055-.03.11-.06.171-.09s.115-.06.171-.085a1.6,1.6,0,0,0,.161-.08c.025-.015.055-.025.085-.04h0c.045-.02.09-.04.13-.06.015-.005.03-.015.045-.02.045-.02.085-.04.13-.055a.269.269,0,0,0,.055-.025c.05-.02.105-.045.161-.065l.12-.045c.01,0,.02-.01.035-.01s.04-.015.06-.025a1.051,1.051,0,0,1,.115-.04c.05-.02.105-.035.155-.055h.01l.286-.09c.1-.03.2-.055.291-.085.035-.01.065-.015.1-.025l.115-.03c.035-.01.07-.015.1-.025.075-.015.15-.035.226-.05l.085-.015a.306.306,0,0,0,.065-.015l.09-.015a.213.213,0,0,0,.055-.01l.1-.015c.105-.02.216-.035.321-.05.03,0,.065-.01.1-.01a.206.206,0,0,0,.055-.005.439.439,0,0,0,.08-.01c.11-.01.226-.025.336-.03a.487.487,0,0,0,.085-.005c.105-.01.206-.015.311-.02h.918c.11,0,.216.01.321.02a.823.823,0,0,1,.115.01h.025a1.154,1.154,0,0,1,.13.015c.2.02.386.045.577.08a.779.779,0,0,1,.105.02.779.779,0,0,1,.105.02l.15.03h0c.05.01.1.02.15.035s.1.025.15.035.1.025.145.035h.01c.05.01.1.025.145.04H38c.045.01.09.025.14.04s.12.035.176.05c.035.01.075.025.11.035h.01l.14.045.135.045c.055.02.11.04.171.06l.125.045c.04.015.085.035.13.05l.04.015c.075.03.15.065.226.1.01,0,.02.01.03.015.045.02.09.04.13.06s.09.04.135.065.09.045.135.065c.09.045.181.09.266.14Z",
    fill: "#34b993"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M28.048,15.975a11.6,11.6,0,0,0-3.19,3.952A11.733,11.733,0,0,0,9.971,24.446a10.4,10.4,0,0,1-4.263-7.082l8.08-9.786a1.407,1.407,0,0,1,1.976-.191,1.369,1.369,0,0,1,.191.191l5.613,6.8,1.475-1.61a1.4,1.4,0,0,1,1.986-.085c.03.03.06.055.085.085l2.939,3.21Z",
    fill: "#14464f"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQqIcon);
export default __webpack_public_path__ + "static/media/QQ-Icon.91af48934dea704871fea683f2c8b87c.svg";
export { ForwardRef as ReactComponent };